import { MenuItem } from '../../../../shared/framework/navigation/models/MenuItem';
import { HomeWidgets } from './HomeWidgets';
import { IWidget } from './IWidget';
import { IWidgetSection } from './IWidgetSection';
import { WidgetSection } from './WidgetSection';


export class Widget {
    constructor(widget?: IWidget) {
        if (!widget) { return; }

        this.id = widget.id;
        this.isFullWidth = widget.isFullWidth;
        this.angularComponent = widget.angularComponent;
        this.widgetSections = widget.widgetSections.map(
            (e: IWidgetSection) => new WidgetSection(e)
        );
        this.angularComponent = widget.angularComponent;
        this.cssIcon = widget.cssIcon;
        this.menuItem = new MenuItem(widget.menuItem);
        this.menuItemId = widget.menuItemId;
        this.position = widget.position;
        this.showIfEmpty = widget.showIfEmpty;
        this.showAddIfEmpty = widget.showAddIfEmpty;
        this.numberOfItemsToShow = widget.numberOfItemsToShow;
        this.collapsed = widget.collapsed;
        this.showGraph = widget.showGraph;
        this.hideWidget = widget.hideWidget;
        this.customIcon = widget.customIcon;
        this.customCssIcon = widget.customCssIcon;
        this.component = this._getComponent();
    }

    id: number;
    menuItemId: number;
    position: number;
    isMandatory: boolean;
    isFullWidth: boolean;
    showIfEmpty: boolean;
    showAddIfEmpty: boolean;
    numberOfItemsToShow: number;
    collapsed: boolean;
    showGraph: boolean;
    hideWidget: boolean;
    menuItem: MenuItem;
    widgetSections: WidgetSection[];
    component: HomeWidgets;

    /** Font-awesome Icon appointed by PROGRESO */
    cssIcon: string;

    /** Custom chosen image (svg or png) */
    customCssIcon: string;

    /** Custom chosen font-awesome icon from library */
    customIcon: string;
    angularComponent: string;

    private _getComponent(): HomeWidgets {
        const c: HomeWidgets = HomeWidgets[this.angularComponent];
        return c || HomeWidgets.TEMP;
    }
}
